import { render, staticRenderFns } from "./PageBlocksTransactions.vue?vue&type=template&id=666e30a1"
import script from "./PageBlocksTransactions.vue?vue&type=script&lang=js"
export * from "./PageBlocksTransactions.vue?vue&type=script&lang=js"
import style0 from "./PageBlocksTransactions.vue?vue&type=style&index=0&id=666e30a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports